import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "join",
  "use": "join-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"join\">\r\n<path d=\"M13 9C13 6.79 11.21 5 9 5C6.79 5 5 6.79 5 9C5 11.21 6.79 13 9 13C11.21 13 13 11.21 13 9ZM15 11V13H18V16H20V13H23V11H20V8H18V11H15ZM1 19V21H17V19C17 16.34 11.67 15 9 15C6.33 15 1 16.34 1 19Z\" fill=\"#3A3A3A\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol